const { InnerBlocks } = wp.blockEditor;

export default function save() {
  return (
    <div className="TabSumicity__content">
      <InnerBlocks.Content />
    </div>
  );
}
